/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import type { Users, Groups } from '../../model/index.tsx';
import getAssociatedSubscription from '../../rest/get-associated-subscriptions/index.tsx';
import { transformResponse } from './transformers.tsx';

const getAssociatedSubscriptions = async (
	filterId: string,
): Promise<{
	users: Users;
	groups: Groups;
}> => {
	const response: {
		subscriptions: {
			items: [];
		};
	} = await getAssociatedSubscription(filterId);
	return transformResponse(response);
};

export default getAssociatedSubscriptions;
